<template>
  <div>
    <v-card>
      <v-data-table v-if="requestStatus"
                    :headers="headers"
                    :items="departments"
                    :items-per-page="15"
                    dense
                    item-key="guid"
                    elevation="0"
                    :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat class="mb-5">
            <v-toolbar-title>Торговые точки</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              hint="Поиск по наименованию, коду, цене"
              persistent-hint
              single-line
              color="orange darken-3"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              color="orange darken-3"
              icon
              outlined
              small
              @click="getData()"
              class="mr-5"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-dialog
              v-model="dialog"
              max-width="330"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="grey darken-3"
                  outlined
                  dark
                  fab
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >П
                </v-btn>
              </template>

              <v-card>
                <v-card-text>
                  <v-row justify="center">
                    <v-date-picker
                      v-model="monthFilter"
                      type="month"
                      @change="setMonthFilter()"
                      show-current
                    ></v-date-picker>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="dialog = false"
                  >
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon outlined small color="primary" @click="viewDepartmentCashshifts(item)" class="mr-2">
            <v-icon>
              mdi-cash-register
            </v-icon>
          </v-btn>
          <v-btn icon outlined small color="primary" @click="viewDepartmentEmployees(item)">
            <v-icon>
              mdi-account-multiple
            </v-icon>
          </v-btn>
        </template>

      </v-data-table>
      <div v-else class="center text-center">
        Загрузка
      </div>
    </v-card>
    <DepartmentEmployeeTable
      v-if="selectedDepartmentEmployees && selectedDepartment"
      :department="selectedDepartment"
      :employees="selectedDepartmentEmployees"
      v-on:close="selectedDepartmentEmployees=null"
    />
    <DepartmentCashshiftsTable
      v-if="selectedDepartmentCashshifts && selectedDepartment"
      :department="selectedDepartment"
      :cashshifts="selectedDepartmentCashshifts.cashshifts"
      v-on:close="selectedDepartmentCashshifts=null"
    />
  </div>
</template>

<script>
import DepartmentEmployeeTable from "@/components/departments/DepartmentEmployeeTable";
import DepartmentCashshiftsTable from "@/components/departments/DepartmentCashshiftsTable";

export default {
  name: "DepartmentsTable",
  props: {},
  components: {DepartmentEmployeeTable, DepartmentCashshiftsTable},
  data: () => ({
    headers: [
      {text: "Наименование", align: "center", value: "name"},
      {text: "Средняя выручка за месяц", align: "center", value: "cashshifts_average"},
      {text: "Кл дней", align: "center", value: "cashshifts_count"},
      {text: "", align: "center", value: "actions", sortable: false, filterable: false},
    ],
    search: '',
    requestStatus: false,
    selectedDepartment: null,
    selectedDepartmentEmployees: null,
    selectedDepartmentCashshifts: null,
    monthFilter: null,
    dialog: false
  }),
  computed: {
    departments() {
      return this.$store.getters.departments
    }
  },
  mounted() {
    this.$root.$refs['departmentTable'] = this
    if (this.$store.getters.departments.length) {
      this.requestStatus = true
      return;
    }
    this.getData()
  },
  methods: {
    getData() {
      this.$api.getDepartmentsWithCashshifts()
        .then(response => {
          this.$store.dispatch("setDepartments", response.data);
          this.requestStatus = true
        })
    },
    viewDepartmentCashshifts(item = null) {
      this.$api.getCashshiftsByDepartmentId(item ? item.id : this.selectedDepartment.id)
        .then(response => {
          this.selectedDepartment = item ? item : this.selectedDepartment
          this.selectedDepartmentEmployees = null
          this.selectedDepartmentCashshifts = response.data
        })
    },
    viewDepartmentEmployees(item) {
      this.$api.getEmployeesByDepartmentId(item.id)
        .then(response => {
          this.selectedDepartment = item
          this.selectedDepartmentCashshifts = null
          this.selectedDepartmentEmployees = response.data
        })
    },
    getErrorEventsCount(department) {
      return department.cashshifts.filter((cashshift) => cashshift.events_error_count > 0);
    },
    setMonthFilter() {
      console.log(this.monthFilter)
      this.$original.axiosConfigDefaults.params['filter_date'] = `${this.monthFilter}-01`
      this.$original.init(() => {
        this.$api = this.$original.client
      })
    }
  },
}
</script>

<style scoped>

</style>